import de from './de/components.json';
import en from './en/components.json';

/**
 * Namespace used for component library translations.
 * Consuming apps should register these translations under this namespace.
 */
export const COMPONENTS_NAMESPACE = 'components';

/**
 * Translation resources for the component library.
 * Import and add these to your i18next configuration.
 *
 * @example
 * import { componentTranslations, COMPONENTS_NAMESPACE } from 'cpool-components/locales';
 *
 * i18n.init({
 *   resources: {
 *     de: { [COMPONENTS_NAMESPACE]: componentTranslations.de },
 *     en: { [COMPONENTS_NAMESPACE]: componentTranslations.en },
 *   },
 * });
 */
export const componentTranslations = {
    de,
    en,
};
